module.exports = __webpack_public_path__ + "img/send.c8f8f951.png";